module.exports = __webpack_public_path__ + "static/img/wave_semicircle.256a78a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oneMachine/wave_semicircle.png
// module id = aY1K
// module chunks = 0